import {useCallback, useEffect, useRef} from "react";

// TODO: investigate lightweight animation libraries that defines these types
// more robustly and also provides a better API overall
type Keyframes = Parameters<HTMLElement["animate"]>[0];
type UseAnimateElementOptions = {
	animateOptions?: Parameters<HTMLElement["animate"]>[1];
	onAnimationFinish?: () => void;
};

const useAnimateElement = <T extends HTMLElement = HTMLElement>(
	keyframes: Keyframes,
	{animateOptions, onAnimationFinish}: UseAnimateElementOptions
) => {
	const ref = useRef<T>(null);
	// store the current animation so it can be cancelled if the component is unmounted
	const currentAnimation = useRef<Animation | null>(null);

	const animate = useCallback(() => {
		if (ref.current) {
			const animation = ref.current.animate(keyframes, animateOptions ?? {});
			currentAnimation.current = animation;
			animation.addEventListener("finish", () => {
				currentAnimation.current = null;
				onAnimationFinish?.();
			});
			animation.addEventListener("cancel", () => {
				currentAnimation.current = null;
			});
			return animation;
		}
	}, [keyframes, animateOptions, onAnimationFinish]);

	useEffect(() => {
		return () => {
			currentAnimation.current?.cancel();
		};
	}, []);

	return {
		ref,
		animate,
	};
};

export default useAnimateElement;
